import { DraftEntry } from './types';

export const EMPTY_FILES: File[] = [];
export const EMPTY_CAPTIONS: Record<string, string> = {};
const EMPTY_DRAFT: DraftEntry = {
  text: '',
  files: EMPTY_FILES,
  captions: EMPTY_CAPTIONS,
  isPrivate: false,
};
export const EMPTY_DRAFTS = new Map<string, DraftEntry>();

export const captionKey = (file: File): string =>
  `${file.name}__${file.size}__${file.lastModified}`;

export const draftHasContent = (draft?: DraftEntry): draft is DraftEntry =>
  !!draft &&
  (draft.text.trim().length > 0 || draft.files.length > 0 || draft.isPrivate);

export const patchDraft = (
  drafts: Map<string, DraftEntry>,
  clientWaNumber: string,
  patch: Partial<DraftEntry>,
): Map<string, DraftEntry> => {
  const next = new Map(drafts);
  const merged: DraftEntry = {
    ...EMPTY_DRAFT,
    ...next.get(clientWaNumber),
    ...patch,
  };
  if (draftHasContent(merged)) next.set(clientWaNumber, merged);
  else next.delete(clientWaNumber);
  return next;
};
